jQuery(document).ready(function ($) {

    /**
     * Search
     */
    $('.beratersuche .search > .searchsubmit').on('click', function () {

        $parent = $(this).closest('.beratersuche');
        $keyword = $parent.find('.search > .searchfield').val();
        $data_attributes = JSON.parse($parent.attr('data-atts'));
        $data_attributes['zip'] = $keyword;
        $parent.attr('data-atts', JSON.stringify($data_attributes));

        fetch_beratersuche_data($data_attributes, $parent.find('.berater'), $(this));

    });

    $('.beratersuche .search > .searchfield').keypress(function (e) {
        if (e.which == 13) {
            // $(this).next('.searchsubmit').trigger('click');
        }
    });


    /**
     * Fetch beratersuche data
     */
    function fetch_beratersuche_data($data_attributes, $output, $this) {
        $output.addClass('loading');
        $.ajax({
            type: 'POST',
            url: CustomBlocks.ajaxurl,
            data: {
                action: 'fetch_beratersuche_data',
                ajaxnonce: CustomBlocks.ajaxnonce,
                attributes: $data_attributes,
            },
            success: function (data, textStatus, XMLHttpRequest) {
                $output.html(data);
                $output.removeClass('loading');
            },
            error: function (MLHttpRequest, textStatus, errorThrown) {
                console.log(errorThrown);
            }
        });

    }



});



// WEBPACK FOOTER //
// ./src/blocks/beratersuche/js/script.js